import { UseFormReturn } from "react-hook-form";
import { InputText } from "@sellar-io/components";
import { InputLabel, InputContainer } from "@sellar-io/components";

export type EditBankDetailsFormFieldValues = {
  bankAccountNumber?: string | null;
  bankSortCode?: string | null;
};

export const EditBankDetailsForm = ({
  form,
  onSubmit,
  formId,
}: {
  form: UseFormReturn<EditBankDetailsFormFieldValues>;
  onSubmit: (data: EditBankDetailsFormFieldValues) => void;
  formId?: string;
}) => {
  return (
    <form
      id={formId}
      onSubmit={form.handleSubmit(onSubmit)}
      className={"flex flex-col gap-2"}
    >
      <InputLabel>Account number</InputLabel>
      <InputContainer>
        <InputText
          placeholder={"12345678"}
          {...form.register("bankAccountNumber", { required: false })}
        />
      </InputContainer>
      <InputLabel>Sort code</InputLabel>
      <InputContainer>
        <InputText
          {...form.register("bankSortCode", { required: false })}
          placeholder={"123456"}
        />
      </InputContainer>
    </form>
  );
};
